// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Toastify__toast-container--bottom-left {
  bottom: 0em !important;
  left: 1em !important;
}

.Toastify__toast {
  margin-bottom: 0.5rem !important;
  border-radius: 5px !important;
}

.Toastify__toast--error {
  background: #000000 !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/toastify.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[".Toastify__toast-container--bottom-left {\n  bottom: 0em !important;\n  left: 1em !important;\n}\n\n.Toastify__toast {\n  margin-bottom: 0.5rem !important;\n  border-radius: 5px !important;\n}\n\n.Toastify__toast--error {\n  background: #000000 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
